import React from 'react';
import { TeamCard } from './TeamCard'
import { Team } from '../constants/types'

interface HomeGridProps {
  teams: Team[];
}

export const HomeGrid = ({ teams }: HomeGridProps) => {
  const sortedTeams = teams.sort((a, b) => a.name.localeCompare(b.name))

  return (
    <div className="home-grid">
      {sortedTeams.map((team, index) => (
        <TeamCard key={index} team={team} />
      ))}
    </div>
  )
};
